
import { AxiosResponse } from 'axios';
import { Console } from 'console';
import { createContext, useEffect,useState,useCallback} from 'react';
import {signIn, signUp,SignInData,SignUpData, me, getImageIfExist, refreshToken} from '../services/resources/user';
import { BASE_URL_FROM_BUCKET } from '../utils/request-image';
import api from '../utils/requests';



interface UserDto{
    
    
    token: string;
    id: string;
    userId?: string;
    accountId?: string;
    slug: string;
    email: string;
    password: string;
    status: string;
    perfis: string;
    lastName:string;
    verification:string;
    creci?:string;
    start?:string;
    endDate?:string;
    imageUrl?:string;
    domain?:string;
    phone?:string;
    account?: {
        id: string;
        domain: string;
        companyName: string;
        customDomain?: string;
    };
    
}

interface ContextData{
   user: UserDto;
   userSignIn: (userData: SignInData) => Promise<any>;
  // userSignUp: (userData: SignUpData) => Promise<UserDto>;
   getCurrentUser: () => Promise<UserDto>;
   refreshTokenUser: () => Promise<any>;
 
   

}

export const AuthContext = createContext<ContextData>({} as ContextData)

export const AuthProvider:React.FC = ({children}) => {


    const [user,setUser] = useState<UserDto>(()=>{

        const user=localStorage.getItem('user');
        

        if(user){
            return JSON.parse(user);
            
        }
        return {} as UserDto;
    });


  
    
         const userSignIn = async (userData: SignInData)=>{
          
        const data = await signIn(userData);
      
        try {
            if(data.response.data !== null){         
                return data.response.data.message;
         
            }
         
        } catch (tokenUser) {
               let userData= await getCurrentUser();
               setUser(userData);
               localStorage.setItem('user',JSON.stringify(userData));
            return data;
       
        }          
    }
    

    const getCurrentUser = async () =>{
        try {
            const {data} = await me();
            setUser(data as UserDto);
            localStorage.setItem('user', JSON.stringify(data));
            return data as UserDto;
        } catch (error) {
            console.error('Erro ao buscar dados do usuário:', error);
            // Só remove o localStorage em caso de erro de autenticação
            localStorage.removeItem('user');
            throw error;
        }
    }



    const refreshTokenUser = async ()=>{
     
        const data = await refreshToken();
      
        try {
            if(data.response.data !== null){ 
                      
                return data.response.data.message;
         
            }
         
        } catch (tokenUser) {
             
        }  
                            
    }
        

    return(
        <AuthContext.Provider value={{user, userSignIn, getCurrentUser,refreshTokenUser}}>
            {children}
        </AuthContext.Provider>
    )
}